import { LOCALSTORAGE_KEYS } from "../constants/users";
import { getToken, removeToken, setToken } from "./localStorageCache";
import { dropUnscopedStoreWizardDraft } from "./storeWizardDraft";
import { dropUnscopedBulkCreateDrafts } from "./bulkCreateDraftStorage";

export function getMockUser() {
  return getToken(LOCALSTORAGE_KEYS.mockUser) || null;
}

/** Drop the parent hop so we never nest seller → seller access. */
export function withoutAccessParent(mockUser) {
  if (!mockUser || typeof mockUser !== "object") return null;
  const { accessParent: _ignored, ...rest } = mockUser;
  return rest;
}

/**
 * Enterprise (or other) hop to restore on "Back to admin".
 * Used when Bespoke Threads accessed an enterprise, then a seller.
 */
export function getAccessParent(mockUser = getMockUser()) {
  const parent = mockUser?.accessParent;
  return isImpersonating(parent) ? parent : null;
}

/**
 * True whenever admin access mode is stored — including partial records
 * that only have a tenant host (Bespoke Admin Panel enterprise Access).
 * The strip and exit controls must not require `uid`; that field is
 * missing on some enterprise docs and older access paths.
 */
export function isImpersonating(mockUser = getMockUser()) {
  if (!mockUser || typeof mockUser !== "object") return false;
  return Boolean(
    mockUser.uid ||
      mockUser.currentDomain ||
      mockUser.email ||
      mockUser.displayName ||
      mockUser.name
  );
}

export function impersonationLabel(mockUser, enterprise) {
  return (
    enterprise?.name ||
    mockUser?.enterprise?.name ||
    mockUser?.name ||
    mockUser?.displayName ||
    mockUser?.businessName ||
    mockUser?.email ||
    mockUser?.currentDomain ||
    "Seller account"
  );
}

export function exitImpersonation({ redirectTo = "/dashboard" } = {}) {
  dropUnscopedStoreWizardDraft();
  dropUnscopedBulkCreateDrafts();
  const parent = getAccessParent();
  if (parent) {
    setToken(LOCALSTORAGE_KEYS.mockUser, parent);
  } else {
    removeToken(LOCALSTORAGE_KEYS.mockUser);
  }
  window.location.href = redirectTo;
}
